<script>
import { mixin as clickaway } from 'vue3-click-away';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import StickerPanel from './StickerPanel.vue';

export default {
  name: 'DinastiaActionsMenu',
  components: { Icon, StickerPanel },
  mixins: [clickaway],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'openLocation', 'openButtons', 'openList', 'sendSticker'],
  data() {
    return {
      showStickerPanel: false,
    };
  },
  methods: {
    close() {
      this.showStickerPanel = false;
      this.$emit('close');
    },
    toggleStickerPanel() {
      this.showStickerPanel = !this.showStickerPanel;
    },
    onStickerSelected(sticker) {
      this.showStickerPanel = false;
      this.$emit('sendSticker', sticker);
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div
    v-if="show"
    v-on-clickaway="close"
    class="absolute bottom-full left-0 mb-2 z-50 bg-white dark:bg-n-solid-3 rounded-xl shadow-lg border border-n-weak dark:border-n-strong"
    :class="showStickerPanel ? 'w-[320px]' : 'min-w-[200px] overflow-hidden'"
  >
    <!-- Menu buttons -->
    <div v-if="!showStickerPanel" class="py-1">
      <button
        class="flex items-center gap-2 w-full px-4 py-2.5 text-sm text-n-slate-12 hover:bg-n-alpha-2 transition-colors"
        @click.stop="toggleStickerPanel"
      >
        <Icon icon="i-ph-sticker" class="size-4 text-n-slate-11" />
        {{ $t('CONVERSATION.DINASTIA_ACTIONS.STICKER.LIBRARY_TITLE') }}
      </button>
      <!-- Hidden for now — may be re-enabled later -->
      <button
        v-if="false"
        class="flex items-center gap-2 w-full px-4 py-2.5 text-sm text-n-slate-12 hover:bg-n-alpha-2 transition-colors"
        @click="$emit('openLocation')"
      >
        <Icon icon="i-ph-map-pin" class="size-4 text-n-slate-11" />
        {{ $t('CONVERSATION.DINASTIA_ACTIONS.SEND_LOCATION') }}
      </button>
      <button
        v-if="false"
        class="flex items-center gap-2 w-full px-4 py-2.5 text-sm text-n-slate-12 hover:bg-n-alpha-2 transition-colors"
        @click="$emit('openButtons')"
      >
        <Icon icon="i-ph-rows" class="size-4 text-n-slate-11" />
        {{ $t('CONVERSATION.DINASTIA_ACTIONS.BUTTONS.TITLE') }}
      </button>
      <button
        v-if="false"
        class="flex items-center gap-2 w-full px-4 py-2.5 text-sm text-n-slate-12 hover:bg-n-alpha-2 transition-colors"
        @click="$emit('openList')"
      >
        <Icon icon="i-ph-list-bullets" class="size-4 text-n-slate-11" />
        {{ $t('CONVERSATION.DINASTIA_ACTIONS.LIST.TITLE') }}
      </button>
    </div>

    <!-- Sticker panel (replaces menu content) -->
    <StickerPanel
      v-else
      @send="onStickerSelected"
      @close="showStickerPanel = false"
    />
  </div>
</template>
